import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { RoutePathLoaderArgs } from '#/routing/classes/types/RoutePathLoaderArgs';
import { movementPath } from '#/routing/routes';
import type { RouteProps } from '#/routing/types/RouteProps';

import { MovementPage } from './Movement.page';

export function loader(_: RoutePathLoaderArgs<typeof movementPath>) {}

export default function MovementRoute(_: RouteProps<typeof loader>) {
  const { i18n } = useI18n();

  return (
    <RouteModule
      title={i18n('Interest Form')}
      linkRels={{ canonical: movementPath.with({}) }}
    >
      <MovementPage />
    </RouteModule>
  );
}
